// extracted by mini-css-extract-plugin
export default {"container":"style_container__s5zRV","content":"style_content__6JOuK","title":"style_title__sh8kF","title_header":"style_title_header__tj5Ol","title_inner":"style_title_inner__aX5YK"};